import { render, staticRenderFns } from "./index.vue?vue&type=template&id=cb11ed28&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&id=cb11ed28&lang=scss&scoped=true&"
import style1 from "./index.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb11ed28",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {TheBurgerMenu: require('/web/components/TheBurgerMenu.vue').default,LinkedObjectPublic: require('/web/components/LinkedObjectPublic.vue').default})
